import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { Columns, Icon, Tooltip, LocalizedText, LineLoader } from 'labguard-cdk'
import { channelStatus } from 'src/entities'
import { usePollingQuery } from 'src/hooks'

const query = gql`
  query channelStatus($id: ID!) {
    channel(id: $id) {
      id
      status
    }
  }
`

const ChannelStatus = ({ channelId }) => {
  const { loading, data: { channel: { status = [] } = {} } = {} } = usePollingQuery(query, {
    variables: { id: channelId },
  })

  const enhancedStatus = React.useMemo(
    () =>
      Object.entries(channelStatus).reduce((acc, [id, { i18n, icon, color, group }]) => {
        const value = { id, i18n, icon, color, group, active: status.includes(id) }
        const groupIndex = !group ? -1 : acc.findIndex(s => s.group === group)
        if (groupIndex === -1) {
          acc.push(value)
        } else if (value.active) {
          acc[groupIndex] = value
        }
        return acc
      }, []),
    [status]
  )

  return (
    <Columns align="center">
      {loading ? (
        <LineLoader height="20" />
      ) : (
        enhancedStatus.map(({ id, i18n, icon, color, active }) => (
          <Tooltip key={id} title={active ? <LocalizedText id={i18n} /> : ''}>
            <Icon icon={icon} color={active ? color : 'dark'} size="xl" opacity={active ? 1 : 0.05} />
          </Tooltip>
        ))
      )}
    </Columns>
  )
}

ChannelStatus.propTypes = {
  channelId: PropTypes.string,
}

export default React.memo(ChannelStatus)
